export default __webpack_public_path__ + "static/DSC_0062-54184a4854e52888ccf7bb88c964cba7.jpg";